import { LoggerUtil } from 'core/utils/loggerUtil.ts';

export function redditAnalyticsUtil(eventType, eventData = {}) {
	if (window.rdt) {
		window.rdt('track', eventType, eventData);
	} else {
		LoggerUtil.logWarning("Reddit tracking 'rdt' not found on window object");
	}
}
